module.exports = __webpack_public_path__ + "img/one.0e6561e1.svg";